export const GET_POLLS = 'GET_POLLS'
export const GET_POLL = 'GET_POLL'
export const NEW_POLL = 'NEW_POLL'
export const SAVE_POLL = 'SAVE_POLL'
export const FINISH_POLL = 'FINISH_POLL'
export const DELETE_POLL = 'DELETE_POLL'
export const GET_POLL_RESULTS = 'GET_POLL_RESULTS'
export const GET_POLL_EXCEL = 'GET_POLL_EXCEL'